/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface AgencyGroupFormValidationData
 */
export interface AgencyGroupFormValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AgencyGroupFormValidationData
     */
    label?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AgencyGroupFormValidationData
     */
    effectiveDates?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AgencyGroupFormValidationData
     */
    brandAndMarket?: ValidationMessage;
}

export function AgencyGroupFormValidationDataFromJSON(json: any): AgencyGroupFormValidationData {
    return AgencyGroupFormValidationDataFromJSONTyped(json, false);
}

export function AgencyGroupFormValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgencyGroupFormValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': !exists(json, 'label') ? undefined : ValidationMessageFromJSON(json['label']),
        'effectiveDates': !exists(json, 'effectiveDates') ? undefined : ValidationMessageFromJSON(json['effectiveDates']),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : ValidationMessageFromJSON(json['brandAndMarket']),
    };
}

export function AgencyGroupFormValidationDataToJSON(value?: AgencyGroupFormValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': ValidationMessageToJSON(value.label),
        'effectiveDates': ValidationMessageToJSON(value.effectiveDates),
        'brandAndMarket': ValidationMessageToJSON(value.brandAndMarket),
    };
}


